import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Textarea.module.css';
export const Textarea = forwardRef(function Textarea({ className, ...rest }, ref) {
    const classes = [styles.textarea, className].filter(Boolean).join(' ');
    return _jsx("textarea", { ref: ref, className: classes, ...rest });
});
//# sourceMappingURL=Textarea.js.map